import React, { useState, useRef, useEffect } from "react";
import { Content, Panel } from './DataStructures';
import PanelListItem from "./PanelListItem";
import { uniqueId } from "./util";
import Button from "react-bootstrap/Button";
const DEBUG = false;
function PanelList(props) {
  var _props$data$panels, _props$data$panels2, _props$data$panels3, _props$data$panels4;
  DEBUG && console.log("dragdrop PanelList dropGeneration", props.dropGeneration);

  // Generate toolbar button refs
  const toolbarRefs = useRef([]);
  toolbarRefs.current = Array(1 + (((_props$data$panels = props.data.panels) === null || _props$data$panels === void 0 ? void 0 : _props$data$panels.length) || 0)).fill(0).map((ref, i) => toolbarRefs.current[i] = /*#__PURE__*/React.createRef());
  // toolbar cursor
  const [toolbarCursor, setToolbarCursor] = useState(0);
  const [outOfFocus, setOutOfFocus] = useState(true);
  const [inDropdown, setInDropdown] = useState(false);
  // // when left or right arrow pressed, change the toolbarCursor
  const handleKeyDown = e => {
    if (e.key === 'ArrowLeft' && 0 < toolbarCursor) {
      setOutOfFocus(false);
      setToolbarCursor(toolbarCursor - 1);
    } else if (e.key === 'ArrowRight' && toolbarCursor < toolbarRefs.current.length - 1) {
      setOutOfFocus(false);
      setToolbarCursor(toolbarCursor + 1);
    } else if (e.key === 'ArrowDown' && !inDropdown) {
      setInDropdown(!inDropdown);
    }
  };
  // when toolbarCursor changes, change focus
  useEffect(() => {
    if (!outOfFocus) focusPanelList();
  }, [toolbarCursor]);
  useEffect(() => {
    if (!inDropdown && !outOfFocus) focusPanelList();
  }, [inDropdown]);
  useEffect(() => {
    DEBUG && console.log("PanelList out of focus", outOfFocus);
  }, [outOfFocus]);
  const onClick = React.useCallback(() => {
    props.data.panels.push(new Panel({
      children: new Content()
    }));
    props.onClick(props.data.panels.length - 1);
    props === null || props === void 0 ? void 0 : props.onChanged();
  }, [props.data, props.onClick]);
  const focusToolboxSearch = () => {
    setOutOfFocus(true);
    props.focusToolboxSearch();
  };
  const focusSettingsButton = () => {
    setOutOfFocus(true);
    props.focusSettingsButton();
  };
  const focusPanelList = () => {
    toolbarRefs.current[toolbarCursor].current.focus();
    DEBUG && console.log("PanelList focusing panel", toolbarCursor + 1);
  };
  const focusPanelListIn = () => {
    setOutOfFocus(false);
    focusPanelList();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "sr-only",
    "aria-hidden": "true",
    tabIndex: 0,
    onFocus: focusPanelListIn
  }), /*#__PURE__*/React.createElement("div", {
    className: "sr-only",
    "aria-hidden": "true",
    tabIndex: 0,
    onFocus: focusSettingsButton
  }), props.data && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex"
    },
    onKeyDown: handleKeyDown
  }, props.data.panels.map((panel, i) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PanelListItem, {
      key: uniqueId(panel),
      onChanged: props.onChange,
      panel: panel,
      i: i,
      data: props.data,
      onClick: props.onClick,
      selectedPage: props.selectedPage,
      onDrop: props.onDrop,
      tabIndex: toolbarCursor == i ? 0 : -1,
      "aria-selected": toolbarCursor == i ? true : false,
      theRef: toolbarRefs.current[i],
      role: "button",
      focusToolboxSearch: focusToolboxSearch,
      focusSettingsButton: focusSettingsButton,
      toggleInDropdown: () => {
        setInDropdown(!inDropdown);
      }
    }));
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    title: "Add panel",
    className: "d-block mt-2",
    style: {
      margin: "5px 5px"
    },
    onClick: () => {
      setToolbarCursor(toolbarCursor + 1);
      onClick();
    },
    role: "button",
    tabIndex: toolbarCursor == (((_props$data$panels2 = props.data.panels) === null || _props$data$panels2 === void 0 ? void 0 : _props$data$panels2.length) || 0) ? 0 : -1,
    "aria-selected": toolbarCursor == (((_props$data$panels3 = props.data.panels) === null || _props$data$panels3 === void 0 ? void 0 : _props$data$panels3.length) || 0) ? true : false,
    ref: toolbarRefs.current[((_props$data$panels4 = props.data.panels) === null || _props$data$panels4 === void 0 ? void 0 : _props$data$panels4.length) || 0]
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-lg"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sr-only",
    "aria-hidden": "true",
    tabIndex: 0,
    onFocus: focusToolboxSearch
  }), /*#__PURE__*/React.createElement("div", {
    className: "sr-only",
    "aria-hidden": "true",
    tabIndex: 0,
    onFocus: focusPanelListIn
  }));
}
export default PanelList;